"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Denom = void 0;
var Denom;
(function (Denom) {
    Denom.LUNA = 'uluna';
    Denom.AUD = 'uaud';
    Denom.CAD = 'ucad';
    Denom.CHF = 'uchf';
    Denom.CNY = 'ucny';
    Denom.DKK = 'udkk';
    Denom.EUR = 'ueur';
    Denom.GBP = 'ugbp';
    Denom.HKD = 'uhkd';
    Denom.IDR = 'uidr';
    Denom.INR = 'uinr';
    Denom.JPY = 'ujpy';
    Denom.KRW = 'ukrw';
    Denom.MNT = 'umnt';
    Denom.NOK = 'unok';
    Denom.PHP = 'uphp';
    Denom.SDR = 'usdr';
    Denom.SEK = 'usek';
    Denom.SGD = 'usgd';
    Denom.THB = 'uthb';
    Denom.USD = 'uusd';
})(Denom = exports.Denom || (exports.Denom = {}));
//# sourceMappingURL=Denom.js.map